<template>
  <v-container style="margin-top: 90px; margin-bottom: 70px;">
    <v-row class="d-flex justify-center">
      <v-card style="width: 757px; max-width: 100%; padding-bottom: 40px;">
        <div class="title-style">
          <span>יצירת eSIM</span>
        </div>
        <div style="padding-left: 10%; padding-right: 10%;">
          <div style="border-top: 1px solid #e4e4e4; padding-bottom: 0px !important;"></div>
        </div>
        
        <!-- תצוגת QR ומספר טלפון לאחר יצירה מוצלחת -->
        <div v-if="esimData.qr" class="esim-result">
          <v-row class="d-flex justify-center align-center mt-5">
            <v-col cols="12" md="6" class="text-center">
              <div class="qr-container">
                <img :src="esimQrImage" alt="eSIM QR Code" class="qr-image" ref="qrImage" />
              </div>
              <div class="mt-3">
                <v-btn color="#0099cd" outlined small class="mx-1" @click="copyQrToClipboard">
                  <v-icon left small>mdi-content-copy</v-icon>
                  העתק QR
                </v-btn>
                <v-btn color="#0099cd" outlined small class="mx-1" @click="downloadQr">
                  <v-icon left small>mdi-download</v-icon>
                  הורד QR
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="text-center">
              <div class="esim-info">
                <v-icon size="48" color="#0099cd">mdi-sim</v-icon>
                <div class="mt-3">
                  <span style="font-size: 16px; color: #666;">מספר טלפון:</span>
                </div>
                <div class="phone-display">
                  <span style="font-size: 24px; font-weight: bold; color: #0099cd; direction: ltr;">
                    {{ esimData.msisdn }}
                  </span>
                  <v-btn icon small @click="copyPhoneNumber" class="mr-2">
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </div>
                <div class="mt-3" style="font-size: 14px; color: #888;">
                  סרוק את קוד ה-QR כדי להתקין את ה-eSIM במכשיר שלך
                </div>
              </div>
            </v-col>
          </v-row>
          <div class="text-center mt-5">
            <v-btn color="#0099cd" outlined @click="resetEsim">
              <v-icon left>mdi-refresh</v-icon>
              יצירת eSIM חדש
            </v-btn>
          </div>
        </div>

        <!-- כפתור יצירת eSIM -->
        <div v-else class="text-center mt-8">
          <div style="margin-bottom: 20px; color: #666;">
            <v-icon size="64" color="#0099cd">mdi-sim-outline</v-icon>
            <p class="mt-3">לחץ על הכפתור ליצירת eSIM חדש</p>
          </div>
          <v-btn @click="createEsim()" color="#0099cd" width="243" max-width="100%" height="48" rounded
            :loading="esimLoading" :disabled="esimLoading">
            <span class="white--text" style="font-weight: bold; font-size: 18px;">צור eSIM</span>
          </v-btn>
        </div>

        <v-row v-if="esimLoading" class="my-5">
          <v-col class="d-flex justify-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-col>
        </v-row>
        <div v-if="esimError" style="text-align: center; margin-top: 15px;">
          <span style="color: red; font-weight: 700;">{{ esimError }}</span>
        </div>
      </v-card>
    </v-row>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-container>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  name: 'EsimActivate',
  components: {
    SnackBar
  },
  data() {
    return {
      esimLoading: false,
      esimError: '',
      esimData: {
        qr: null,
        msisdn: null
      },
      snackbar: false,
      snackbarColorBt: "green",
      snacbarText: ""
    };
  },
  computed: {
    esimQrImage() {
      if (this.esimData.qr) {
        if (this.esimData.qr.startsWith('data:image')) {
          return this.esimData.qr;
        }
        return `data:image/png;base64,${this.esimData.qr}`;
      }
      return null;
    }
  },
  methods: {
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },

    async createEsim() {
      try {
        this.esimLoading = true;
        this.esimError = '';
        
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + "/seller/create_esim";
        
        const res = await fetch(api, ApiServices.requestOptions("POST", JSON.stringify({}), token));
        
        this.esimLoading = false;
        
        if (res.status === 200) {
          const data = await res.json();
          this.esimData = {
            qr: data.qr,
            msisdn: data.msisdn
          };
          this.showSnackBar("eSIM נוצר בהצלחה!", "green");
        } else if (res.status > 400) {
          const jsonObject = await res.json();
          this.esimError = jsonObject.message || "שגיאה ביצירת eSIM";
          this.showSnackBar("שגיאה: " + this.esimError, "red");
        } else {
          this.esimError = "שגיאה לא צפויה";
          this.showSnackBar("שגיאה ביצירת eSIM", "red");
        }
      } catch (error) {
        this.esimLoading = false;
        this.esimError = "שגיאת תקשורת";
        this.showSnackBar("Error creating eSIM: " + error, "red");
      }
    },
    
    resetEsim() {
      this.esimData = {
        qr: null,
        msisdn: null
      };
      this.esimError = '';
    },
    
    async copyQrToClipboard() {
      try {
        const img = this.$refs.qrImage;
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        
        canvas.toBlob(async (blob) => {
          try {
            await navigator.clipboard.write([
              new ClipboardItem({ 'image/png': blob })
            ]);
            this.showSnackBar("QR הועתק ללוח!", "green");
          } catch (err) {
            await navigator.clipboard.writeText(this.esimQrImage);
            this.showSnackBar("QR הועתק ללוח!", "green");
          }
        }, 'image/png');
      } catch (error) {
        this.showSnackBar("שגיאה בהעתקה: " + error, "red");
      }
    },
    
    downloadQr() {
      try {
        const link = document.createElement('a');
        link.href = this.esimQrImage;
        link.download = `esim_${this.esimData.msisdn || 'qr'}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.showSnackBar("QR הורד בהצלחה!", "green");
      } catch (error) {
        this.showSnackBar("שגיאה בהורדה: " + error, "red");
      }
    },
    
    async copyPhoneNumber() {
      try {
        await navigator.clipboard.writeText(this.esimData.msisdn);
        this.showSnackBar("מספר הטלפון הועתק!", "green");
      } catch (error) {
        this.showSnackBar("שגיאה בהעתקה", "red");
      }
    }
  }
};
</script>

<style scoped>
.title-style {
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  margin-top: 30px;
}

.esim-result {
  padding: 20px;
}

.qr-container {
  display: inline-block;
  padding: 15px;
  background: white;
  border: 2px solid #0099cd;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 153, 205, 0.15);
}

.qr-image {
  max-width: 200px;
  max-height: 200px;
  width: 100%;
  height: auto;
}

.esim-info {
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  margin: 10px;
}

.phone-display {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

@media (max-width: 600px) {
  .qr-image {
    max-width: 150px;
    max-height: 150px;
  }
  
  .esim-info {
    margin-top: 20px;
  }
}
</style>